import { createAction } from 'redux-actions';
export const SET_EVERY_PORT_ACTION = 'SET_EVERY_PORT_ACTION';
export const SET_ALL_EVERY_PORT_ACTION = 'SET_ALL_EVERY_PORT_ACTION';
export const setEveryPortServiceAction = createAction(SET_EVERY_PORT_ACTION);
export const setAllEveryPortAction = createAction(SET_ALL_EVERY_PORT_ACTION);
